/*
 * トップ KV のクロスフェード スライドショー（UI なし・自動再生のみ＝背景動画的なアンビエント表現）。
 * markup は sections/hero-banner.liquid、見た目は assets/custom.css の `.hero-banner*`。
 *
 * 挙動:
 *   - data-autoplay="true" かつ複数スライドのときだけ自動再生（既定 5 秒・data-interval[ms]）。
 *   - active スライドに .is-active を付け替えて opacity でクロスフェード（遷移の長さ・イージングは CSS）。
 *   - prefers-reduced-motion では自動再生しない＝先頭スライドを静止表示（JS 無効時のフォールバックと同じ）。
 *     映像的なアンビエント表現なので、停止手段はこの OS 設定に一本化する（ホバー/フォーカス一時停止は持たない・ユーザー確定 2026-06-29）。
 *   - disconnectedCallback でタイマーを必ず解除（テーマエディタの再描画でリークしない）。
 * インジケーター/矢印/テキストは持たない（ユーザー確定 2026-06-29＝ビジュアルのみ）。
 */
class HeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.hero-banner__slide'));
    this.interval = parseInt(this.dataset.interval, 10) || 5000;
    this.index = 0;
    this.timer = null;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    // 自動再生しない条件（手動 UI は無いので、この場合は先頭スライドの静止表示で終わり）
    if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || reduceMotion.matches) {
      return;
    }

    this.timer = window.setInterval(() => this.next(), this.interval);
  }

  disconnectedCallback() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  next() {
    const prev = this.slides[this.index];
    this.index = (this.index + 1) % this.slides.length;
    const curr = this.slides[this.index];

    prev.classList.remove('is-active');
    prev.setAttribute('aria-hidden', 'true');
    curr.classList.add('is-active');
    curr.removeAttribute('aria-hidden');
  }
}

customElements.define('hero-slideshow', HeroSlideshow);
